module.exports = __webpack_public_path__ + "static/img/am09.3e20691.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/am09.jpg
// module id = ge+R
// module chunks = 1